import script from "./TechnicianBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicianBottomNav.vue?vue&type=script&setup=true&lang=js"

import "./TechnicianBottomNav.vue?vue&type=style&index=0&id=24243d44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24243d44"]])

export default __exports__